import {Alert as BaseAlert, AlertProps, Color as AlertColor} from '@material-ui/lab'
import React from 'react'

import {InfoIcon, WarningIcon} from '../../icons'
import {SystemColors, Theme, withStyles} from '../../theme'

const iconMapping: AlertProps['iconMapping'] = {
  info: <InfoIcon />,
  warning: <WarningIcon />,
}

const Alert: React.FC<React.PropsWithChildren<AlertProps>> = props => <BaseAlert iconMapping={iconMapping} {...props} />

/** @deprecated - использовать ТОЛЬКО в /order */
export type {AlertColor, AlertProps}
/** @deprecated - использовать ТОЛЬКО в /order */
const CustomAlert = withStyles(
  (theme: Theme) => ({
    root: {
      borderRadius: 8,
      '& a': {
        color: theme.go.schemes.colors.system[SystemColors.TextInvert],
      },
    },
    icon: {},
    standardInfo: {
      color: theme.go.schemes.colors.system[SystemColors.TextMain],
      backgroundColor: theme.go.schemes.colors.system[SystemColors.ControlMinor],
      '& $icon': {
        color: theme.go.schemes.colors.system[SystemColors.TextMinor],
      },
      '& $Link, & a': {
        color: theme.go.schemes.colors.system[SystemColors.Link],
      },
    },
    standardWarning: {
      color: '#5e3903',
      backgroundColor: 'rgb(255 235 178)',
      '& $icon': {
        color: '#9c681c',
      },
    },
    standardError: {
      color: theme.go.schemes.colors.system[SystemColors.TextInvert],
      backgroundColor: theme.go.schemes.colors.system[SystemColors.BgAttention],
      '& $icon': {
        color: theme.go.schemes.colors.system[SystemColors.TextInvert],
      },
    },
  }),
  {name: 'LFAlert'},
)(Alert)

export default CustomAlert
